import React, { useState } from 'react';

import NotificationView from './components/NotificationView/NotificationView';
import ActivityView from './components/ActivityView/ActivityView';

import styles from './Notification.module.css';


function Notification() {

  const [currentTab, setCurrentTab] = useState('Notifications');

  const tabs = [
    'Notifications',
    'Activity',
  ];

  const handleTab = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <div className='mx-2 px-1'>
      <div className={styles.upperRow}>
        {tabs.length !== 0 && tabs.map((tab, index) => (
          <a
            key={index}
            className={currentTab === tab ? `${styles.tabBox} ${styles.active}` : `${styles.tabBox}`}
            onClick={() => handleTab(tab)}
          >
            {tab}
          </a>
        ))}
      </div>
      {currentTab === 'Notifications' && <NotificationView />}
      {currentTab === 'Activity' && <ActivityView />}
    </div>
  );

};

export default Notification;